
import createHeaders from "@utils/createHeaders";

export const headers = createHeaders([
  { text: 'No', align: 'start', value: 'number_index', width: '10' },
  { text: 'Kode Bank', value: 'bank_code'},
  { text: 'Kode NNS', value: 'bank_nns'},
  { text: 'Nama PJSP', value: 'bank_name'},
  { text: 'Brand Name', value: 'brand_name'},
  { text: 'Created Date', value: 'created_at'},
  { text: 'Action', value: 'action', width: '10' }
]);

export const search = {
  bank_code: '',
  bank_nns: '',
  bank_name: '',
  brand_name: '',
  created_at: null,
};

export const editedItem = {
  bank_code: '',
  bank_nns: '',
  bank_name: '',
  brand_name: '',
};

export const defaultItem = {
  bank_code: '',
  bank_nns: '',
  bank_name: '',
  brand_name: '',
};
